/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UsernameValidationStatusEnumDTO } from './UsernameValidationStatusEnumDTO';
import {
    UsernameValidationStatusEnumDTOFromJSON,
    UsernameValidationStatusEnumDTOFromJSONTyped,
    UsernameValidationStatusEnumDTOToJSON,
} from './UsernameValidationStatusEnumDTO';

/**
 * 
 * @export
 * @interface UsernameValidationStatusDTO
 */
export interface UsernameValidationStatusDTO {
    /**
     * 
     * @type {UsernameValidationStatusEnumDTO}
     * @memberof UsernameValidationStatusDTO
     */
    status: UsernameValidationStatusEnumDTO;
}



/**
 * Check if a given object implements the UsernameValidationStatusDTO interface.
 */
export function instanceOfUsernameValidationStatusDTO(value: object): value is UsernameValidationStatusDTO {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UsernameValidationStatusDTOFromJSON(json: any): UsernameValidationStatusDTO {
    return UsernameValidationStatusDTOFromJSONTyped(json, false);
}

export function UsernameValidationStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsernameValidationStatusDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'status': UsernameValidationStatusEnumDTOFromJSON(json['status']),
    };
}

export function UsernameValidationStatusDTOToJSON(value?: UsernameValidationStatusDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': UsernameValidationStatusEnumDTOToJSON(value['status']),
    };
}

